export enum CmmResponseStatus {
  APPROVED = "Approved",
  PENDING = "Pending",
  APPROVAL_ON_FILE = "Approval on file",
  DENIAL_ON_FILE = "Denial on file",
  INACCURACY = "Inaccuracy",
  IN_PROGRESS = "In Progress",
  FORM_ERROR = "Form Error",
  FORM_FILLED = "Form Filled",
  SENDING_TO_PLAN = "Sending to Plan",
  SENT_TO_PLAN = "Sent to plan",
  QA_IN_PROGRESS = "QA In Progress",
  DRUG_NOT_COVERED = "Drug Not Covered",
  QA_ERROR = "Qa Error",
  QA_FETCHED = "QA Fetched",
  VERIFIED = "Verified",
  DENIED = "Denied",
  UNSPECIFIED = "Unspecified",
  AUTH_ON_FILE = "Auth on file",
  AUTH_NOT_REQUIRED = "Auth Not Required",
  COMPLETED = "completed",
  ONSHORE_ASSISTANCE = "Onshore Assistance",
  WAITING_FOR_CLINICAL = "Waiting For Clinical",
  NA_OUTCOME = "NA Outcome",
  NOT_CORRECT_PROCESSOR = "Not Correct Processor",
  SEND_TO_CLIENT = "Send To Client",
}
